<template>
  <i-dx-popup :popupVisible="popupVisible" :title="title" @popupCloseButtonClick="closeBtn(false)" height="90vh" width="60vw">
    <template v-slot:grid>
      <v-form ref="form" class="cancel-popup-form">
        <v-card class="cancel-popup-card v-application">
          <v-row no-gutters class="cancel-popup-row">
            <!-- 좌측 결제 정보 및 환불 규정 -->
            <v-col cols="6" class="cancel-popup-left">
              <div class="cancel-section cancel-section-usage">
                <v-card class="cancel-request-date-card pa-2 mb-2" outlined elevation="0">
                  <v-card-text class="cancel-request-date-card-body">
                    <div class="form-label cancel-request-date-label">해지 요청일</div>
                    <div class="cancel-request-date">{{ cancelRequestDt.replaceAll('-', '.') }}</div>
                  </v-card-text>
                </v-card>
                <v-row dense>
                  <calcCancelAmount
                    ref="cca"
                    :orderId="orderId"
                    :cancelRequestDt="cancelRequestDt"
                    :startDate="dtS"
                    :endDate="dtE"
                    :feeCd="feeCd"
                    :isPromotion="paymentData.activeFeeType === 'promotion'"
                    :propsData="paymentData"
                    @done="calcDone"
                  />
                </v-row>
              </div>
              <v-divider class="cancel-divider"></v-divider>
              <div class="cancel-section cancel-section-rules">
                <div class="form-label cancel-rules-title">환불 규정</div>
                <DxScrollView width="100%" height="200px" class="cancel-rules-scroll">
                  <div class="cancel-rules-content">
                    <ul class="cancel-rules-list">
                      <li>결제 승인 전 - 전액 환불</li>
                      <li>결제 승인 후 (미사용) - 7일이내 해지 신청 시 전액 환불</li>
                      <li>결제 승인 후 (미사용) - 1개월 이내 해지 신청 시 월 요금의 1/3을 제한 나머지 금액 환불</li>
                      <li>결제 승인 후 - 사용 일수 일할 계산한 금액 차감후 나머지 금액 환불</li>
                      <li>결제 승인 후 - 남은 사용 기간이 7일 미만인 경우 환불 불가</li>
                    </ul>
                    <div class="cancel-rules-note">
                      <p>※ 미사용이란 회사의 사용 승인 후 '소중안' 시스템에 로그인 이력이 없는 경우를 의미함</p>
                      <p>※ 원단위는 올림 지급 (예: 200,000원의 2/3지급 시 133,333원 => 133,340원)</p>
                      <p>※ 환불 기준 외 안전기술원에서 인정되는 사유가 있을 경우 전액 또는 부분 환불</p>
                      <p>※ 카드 취소는 불가합니다. 계좌이체를 통해 현금으로 환불해 드립니다.</p>
                    </div>
                    <div class="cancel-rules-contact">
                      <p>▶ '소중안'의 모든 거래에 대한 책임과 배송,교환,환불,민원등의 처리는 한국전기공사협회 안전기술원에서 진행합니다.</p>
                      <p>▶ 담당자 연락처 043-711-4341</p>
                    </div>
                  </div>
                </DxScrollView>
              </div>
            </v-col>
            <v-divider vertical class="cancel-divider-vertical"></v-divider>
            <!-- 환불 관련 정보 입력 란 -->
            <v-col class="cancel-popup-right">
              <div class="cancel-section cancel-section-account">
                <h5 class="cancel-section-heading">환불 받으실 계좌정보</h5>
                <v-row dense>
                  <v-col cols="12">
                    <div class="form-label required">은행명</div>
                    <v-text-field
                      v-model="paymentData.refundBank"
                      solo
                      hide-details="auto"
                      :rules="[rules.required]"
                      class="editor_bg cancel-input"
                    />
                  </v-col>
                </v-row>
                <v-row dense>
                  <v-col cols="12">
                    <div class="form-label required">계좌번호</div>
                    <v-text-field
                      v-model="paymentData.refundAccountNumber"
                      solo
                      hide-details="auto"
                      :rules="[rules.required]"
                      class="editor_bg cancel-input"
                    />
                  </v-col>
                </v-row>
                <v-row dense>
                  <v-col cols="12">
                    <div class="form-label required">예금주</div>
                    <v-text-field
                      v-model="paymentData.refundAccountHolder"
                      solo
                      hide-details="auto"
                      :rules="[rules.required]"
                      class="editor_bg cancel-input"
                    />
                  </v-col>
                </v-row>
                <v-row dense class="cancel-reason-row">
                  <v-col cols="12">
                    <div class="form-label required">해지 사유</div>
                    <v-textarea
                      v-model="paymentData.cancelReason"
                      no-resize
                      solo
                      class="editor_bg cancel-input"
                      :rules="[rules.required]"
                      auto-grow
                    />
                  </v-col>
                </v-row>
              </div>
              <div class="cancel-section cancel-section-submit">
                <div class="cancel-total-refund">
                  <span class="cancel-total-label">예상 환불 금액</span>
                  <span class="cancel-total-amount">{{ paymentData.totalRefundAmount }}</span>
                </div>
                <v-btn color="primary" block large @click="btnCancel()" :disabled="!done" class="cancel-submit-btn">해지 신청</v-btn>
              </div>
            </v-col>
          </v-row>
        </v-card>
      </v-form>
    </template>
  </i-dx-popup>
</template>
<script>
import IDxPopup from '@/components/common/iDxPopup.vue'
import baseview from '@/views/base/baseview.vue' //20220414 LYJ base page 추가
import calcCancelAmount from '@/payment/components/calcCancelAmount.vue'
import { DxScrollView } from 'devextreme-vue/scroll-view'
// 유틸
import { getDateDiff, getCurrentDate } from '@/utils/common.js'

// API
import { getCustomerLoginHistoryAferPayment, requestCancel } from '@/payment/api/toss'
import { getDiscountListByFee } from '@/api/feeManage/discountManage.js'

export default {
  mixins: [baseview], //20220414 LYJ base page 추가 및 권한 처리
  components: {
    IDxPopup,
    calcCancelAmount,
    DxScrollView,
  },
  props: {
    // popup 표시 유무
    popupVisible: {
      type: Boolean,
      default: () => false,
    },
    // 제목
    title: {
      type: String,
      default: () => '',
    },
    // 넘겨 받는 데이터
    propsData: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      rules: {
        required: (value) => (!value ? '필수 입력 사항입니다.' : true),
      },
      refundAmountString: '',
      cancelRequestDt: getCurrentDate(),
      customerLoginDate: null,
      discountList: [], // 할인 리스트
      paymentData: {
        useMonth: 0,
        useDay: 0,
        constructDtS: null,
        constructDtE: null,
        feeAmount: 0,
        feeCd: null,
        amountPerMonth: 0,
        amountPerDay: 0,
        paymentAmount: 0,
        calcRefundAmount: 0,
        remainMonth: 0,
        remainDay: 0,
        refundAmountPerMonth: 0,
        refundAmountPerDay: 0,
        vat: 0,
        totalRefundAmount: 0,
      },
      orderId: null,
      dtS: null,
      dtE: null,
      feeCd: null,
      totalDiscountAmount: 0,
      totalDiscountPercent: 0,
      remark: '',
      done: false,
    }
  },
  watch: {
    popupVisible: {
      deep: true,
      handler() {
        if (!this.popupVisible) return
        this.initData()
      },
    },
    paymentData: {
      deep: true,
      handler() {
        this.paymentData = this.propsData
        this.dtS = this.paymentData.constructDtS
        this.dtE = this.paymentData.constructDtE
        this.feeCd = this.paymentData.feeCd
        this.orderId = this.paymentData.orderId
        //this.initData()
      },
    },
  },
  created() {},
  activated() {},
  beforeMount() {
    this.paymentData = this.propsData
    console.log('@@ ', this.paymentData)
  },
  mounted() {
    let params = {
      feeCd: this.propsData.feeCd,
    }
    getDiscountListByFee(params)
      .then((res) => {
        if (res.success) {
          this.discountList = res.list
        }
      })
      .then(() => {
        this.initData()
      })
  },
  methods: {
    initData() {
      //this.calcRefund()
    },
    formatToKoreanWon(value) {
      // 문자열을 입력 받아 한국 원단위로 치환한다.
      if (value) {
        const numberValue = parseFloat(value.toString().replace(/,/g, ''))
        if (!isNaN(numberValue)) {
          return numberValue.toLocaleString('ko-KR')
        }
      } else return 0
    },
    calcRefund() {
      console.log('constructData', this.paymentData)
      // 결제 후 최초 로그인 일자 조회
      const customerParam = {
        clntId: this.getClntId(),
        orderId: this.paymentData.orderId,
      }
      getCustomerLoginHistoryAferPayment(customerParam).then((res) => {
        if (res.loginDate) {
          this.customerLoginDate = res.loginDate
        }
      })

      // 공사일자를 이용해 사용일자 계산
      let useDuration = getDateDiff(this.paymentData.constructDtS, this.paymentData.constructDtE) // 사용 종료일 23:59 - 사용 시작일로 계산한다.
      this.paymentData.useMonth = useDuration.month
      this.paymentData.useDay = useDuration.date

      /* 전체 요금 계산  */

      // 현재 fee_cd 에 대한 금액 관련  부분 조회
      // 선택된 요금제에 해당하는 할인 목록 조회

      let calcAmount = this.paymentData.feeAmount

      // 할인 총량 계산
      this.discountList.forEach((dis) => {
        if (dis.method == '00001') {
          this.totalDiscountAmount += dis.discountAmount
        }
        if (dis.method == '00002') {
          this.totalDiscountPercent += dis.discountPercent
        }
      })

      // 할인 총량 반영 : 1자리 올림 처리
      calcAmount -= this.totalDiscountAmount
      calcAmount = Math.ceil((calcAmount * (100 - this.totalDiscountPercent)) / 100 / 10) * 10
      // 월 금액
      this.paymentData.amountPerMonth = calcAmount
      // 일할 금액
      this.paymentData.amountPerDay = Math.ceil(this.paymentData.amountPerMonth / 30)

      // 고객의 결제 금액
      this.paymentData.paymentAmount =
        this.paymentData.amountPerMonth * this.paymentData.useMonth + this.paymentData.amountPerDay * this.paymentData.useDay

      /* 남은 기간에 해당하는 금액 계산 */
      // 미사용 1개월 이내
      if (this.paymentData.paymentStatus == 'N') {
        this.paymentData.calcRefundAmount = this.paymentData.paymentAmount
        this.remark = '결제 승인 전, 전액 환불'
      } else if (this.customerLoginDate == null && useDuration.month == 0) {
        //미사용 7일 이내
        if (useDuration.date <= 7) {
          // 전액 환불 차감액 없음
          this.paymentData.calcRefundAmount = this.paymentData.paymentAmount
          this.remark = '미사용 7일 이내, 전액 환불'
        } else {
          // 월 요금의 1/3만 차감하여 계산
          this.paymentData.calcRefundAmount = this.paymentData.paymentAmount - this.paymentData.amountPerMonth / 3
          this.remark = '미사용 1개월 이내, 월요금의 1/3만 차감'
        }
      }
      // 사용상태(로그인 이력 있음)인 경우
      else {
        // 남은 기간 (해지 신청일 ~ 사용 종료일)
        let remainDuration = getDateDiff(this.cancelRequestDt, this.paymentData.constructDtE)
        this.paymentData.remainMonth = remainDuration.month
        this.paymentData.remainDay = remainDuration.date
        // 남은 기간이 7일 미만인 경우
        if (remainDuration.month <= 0 && remainDuration.date < 7) {
          // 모든 금액 차감 = 환불 금액 없음
          this.paymentData.remainDay = 0
          this.remark = '남은 기간 7일 미만으로 환불 불가'
        }
        // 남은 기간과 요금에 따른 월/일 별 요금
        this.paymentData.refundAmountPerMonth = this.paymentData.amountPerMonth * this.paymentData.remainMonth
        this.paymentData.refundAmountPerDay = this.paymentData.amountPerDay * this.paymentData.remainDay

        // 합계 환불 금액
        this.paymentData.calcRefundAmount = this.paymentData.refundAmountPerMonth + this.paymentData.refundAmountPerDay
      }

      // 1자리 올림
      this.paymentData.calcRefundAmount = Math.ceil(this.paymentData.calcRefundAmount / 10) * 10
      // VAT
      this.paymentData.vat = this.paymentData.calcRefundAmount / 10

      // 최종 환불 금액
      this.paymentData.totalRefundAmount = this.paymentData.calcRefundAmount + this.paymentData.vat

      // 해지정보 환불 금액 text-field에 출력될 문자열 포맷
      if (this.paymentData.refundAmountPerMonth > 0)
        this.refundAmountString = `${this.formatToKoreanWon(this.paymentData.refundAmountPerMonth)}원 + ${this.formatToKoreanWon(
          this.paymentData.refundAmountPerDay
        )}원 =`
    },
    ///////////////////////////////////////
    /*       Toolbar Button Event        */
    ///////////////////////////////////////
    btnCancel() {
      if (!this.$refs.form.validate()) {
        this.vToastify(this.$t('저장 입력 항목을 확인해주세요.'), 'info')
        return
      }
      console.log('@@@@ this.props', this.paymentData)
      console.log('amt', this.$refs.cca.getAmount(true))
      this.vToastifyPrompt(this.$t('해지 신청을 진행하시겠습니까?'), 'info', async (current) => {
        const cancelParam = {
          clntId: this.paymentData.clntId,
          compId: this.paymentData.compId,

          orderId: this.paymentData.orderId,
          cancelAmount: this.$refs.cca.getAmount(true),
          cancelStatus: 'N',
          refundAccountNumber: this.paymentData.refundAccountNumber,
          refundBank: this.paymentData.refundBank,
          refundAccountHolder: this.paymentData.refundAccountHolder,
          cancelReason: this.paymentData.cancelReason,
        }

        this.openLoading()
        requestCancel(cancelParam, true)
          .then((res) => {
            //
          })
          .catch(() => {
            this.endLoading()
          })
          .finally(() => {
            this.endLoading()
            this.closeBtn(true)
          })
      })
    },
    ///////////////////////////////////////
    /*             etc Event             */
    ///////////////////////////////////////
    // 팝업 닫기
    closeBtn(completed) {
      this.$emit('popupClose', completed)
    },
    calcDone(isDone) {
      this.done = isDone
      this.paymentData.totalRefundAmount = this.formatToKoreanWon(this.$refs.cca.getAmount(true)) + '원'
    },
  },
}
</script>

<style scoped>
.cancel-popup-form {
  height: 100%;
}

.cancel-popup-card {
  padding: 20px 24px;
  box-shadow: none;
  border-radius: 8px;
}

.cancel-popup-row {
  min-height: 100%;
}

.cancel-popup-left {
  padding-right: 20px;
  padding-left: 4px;
}

.cancel-popup-right {
  padding-left: 20px;
  padding-right: 4px;
  display: flex;
  flex-direction: column;
}

.cancel-section {
  margin-bottom: 16px;
}

.cancel-section-usage {
  margin-bottom: 12px;
}

.cancel-section-rules {
  margin-bottom: 0;
}

.cancel-request-date-card {
  border-radius: 8px;
  border: 1px solid rgba(0, 0, 0, 0.08);
  background: linear-gradient(135deg, rgba(25, 118, 210, 0.04) 0%, rgba(25, 118, 210, 0.08) 100%);
  overflow: hidden;
}

.cancel-request-date-card-body {
  padding: 14px 16px;
}

.cancel-request-date-label {
  font-size: 0.8rem;
  font-weight: 600;
  color: rgba(0, 0, 0, 0.5);
  margin-bottom: 6px;
  letter-spacing: -0.01em;
}

.cancel-request-date {
  font-size: 1.05rem;
  font-weight: 600;
  color: rgba(0, 0, 0, 0.85);
  letter-spacing: -0.02em;
}

.cancel-divider {
  margin: 16px 0;
}

.cancel-divider-vertical {
  margin: 0 8px;
}

.cancel-rules-title {
  margin-bottom: 10px;
  font-weight: 600;
  font-size: 0.95rem;
}

.cancel-rules-scroll {
  border: 1px solid rgba(0, 0, 0, 0.12);
  border-radius: 6px;
  padding: 12px 14px;
  background: rgba(0, 0, 0, 0.02);
}

.cancel-rules-content {
  padding: 4px 0;
  font-size: 0.875rem;
  line-height: 1.55;
  color: rgba(0, 0, 0, 0.75);
}

.cancel-rules-list {
  margin: 0 0 12px 0;
  padding-left: 18px;
  list-style-type: disc;
}

.cancel-rules-list li {
  margin-bottom: 6px;
}

.cancel-rules-note p,
.cancel-rules-contact p {
  margin: 0 0 6px 0;
  font-size: 0.8125rem;
  color: rgba(0, 0, 0, 0.65);
}

.cancel-rules-contact {
  margin-top: 10px;
  padding-top: 8px;
  border-top: 1px dashed rgba(0, 0, 0, 0.15);
}

.cancel-section-heading {
  margin: 0 0 14px 0;
  font-size: 1rem;
  font-weight: 600;
  color: rgba(0, 0, 0, 0.85);
}

.cancel-section-account .form-label {
  margin-bottom: 4px;
}

.cancel-input {
  margin-bottom: 4px;
}

.cancel-reason-row {
  margin-top: 4px;
}

.cancel-section-submit {
  margin-top: auto;
  padding-top: 20px;
  border-top: 1px solid rgba(0, 0, 0, 0.1);
}

.cancel-total-refund {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 14px;
  padding: 12px 14px;
  background: rgba(25, 118, 210, 0.06);
  border-radius: 6px;
  border: 1px solid rgba(25, 118, 210, 0.2);
}

.cancel-total-label {
  font-size: 0.9rem;
  font-weight: 600;
  color: rgba(0, 0, 0, 0.75);
}

.cancel-total-amount {
  font-size: 1.1rem;
  font-weight: 700;
  color: #1976d2;
  letter-spacing: -0.02em;
}

.cancel-submit-btn {
  text-transform: none;
  font-weight: 600;
  letter-spacing: -0.01em;
}

.right-input >>> input {
  text-align: right;
}
</style>
